import React from "react";
import "../HTMate/HTMate.scss";

const NewsAndMedia = () => {
  return (
    <div
      className="data-container"
      // style={{
      //   backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
      // }}
    >
      <div className="textitem">
        <h3>News & Media</h3>

        <div className="textitem">
          <h5>News Byte # 1:</h5>
          <p>
            Hlthtek has been rated as one of the top trending Health Tech/ IT
            startups in Eastern India as per the view of multiple academic
            institutions in the West Bengal-Assam-Odisha region in 2024.
          </p>
          <ul>
            <li>IIT Guwahati (IITG)</li>
            <li>ISI Kolkata</li>
            <li>KIIT Bhubaneswar</li>
          </ul>
        </div>

        <div className="textitem">
          <h5>News Byte # 2:</h5>
          <p>
            A partnership was formed in August 2024 with the USA startup
            ‘Pannalabs.ai,’ which is working on Mental Health.
          </p>
        </div>

        <div className="textitem">
          <h5>News Byte # 3:</h5>
          <p>
            Hlthtek is certifying the already implemented ABDM Connectors
            (HTHRP/ HTBridge), EHR/ HMIS solution (HTMATE) from ABDM (Ayushman
            Bharat Digital Mission) implementation and capacity building team
            under the National Health Authority (NHA) of India. Post the
            functional testing, a WASA (Web Application Security Assessment)
            would be conducted by an ABDM approved Software Security Testing
            Agency.
          </p>
        </div>

        <div className="textitem">
          <h5>Media Bytes:</h5>
          <p>
            Hlthtek has launched two YouTube videos showing the strength of
            Hlthtek's vision on digital health and the platform. You can watch
            them by clicking the links below:
          </p>
          <ul>
            <li>
              <a
                href="https://drive.google.com/file/d/1HmA0U7CtPiHfluRo-8qZB70rdD_LSTtm/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Video 1: How Digital Health Records Save Lives
              </a>
            </li>
            <li>
              <a
                href="https://drive.google.com/file/d/1YX-6JbvdeT3yAUrECz7X6rENBZsuGx6D/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Video 2: Digital Guardians: How Records Save Lives
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NewsAndMedia;
